module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAmCAYAAAAm56DSAAABW0lEQVRIia3Vv6vPcRTH8ce93SiDHyk/SgzXHe56V6ORSVkMyiKllORH/A0GgzJgsViMd6DuRjbKcicUinDDokxPw/feVenzPnW2d68edd6do3pWLVWm9jxe4IYRVe2pvleHR8h+4D6ujZCp9lUb1YGpMviKR7gyQqY6tKnbO1UGn/AEl0bIVIvVt2rnVBm8xVNcHCFTLVdfqh1TZbCO5zg/QqZaqT5W26bK4BXe4NwImepY9a5amCpjtk3e48wImep4tV7NT5XBGn7i1AiZ6mT1upqbKoNVzOHECJnqdPVyhIzZNtmN4yNkqrPV2r/e/E/YwuYnPjYiTHWhWh0Vtr3ZAliZMoCt+oPbuDl1AFu9o9nyXJ4qg9+4g1sjZKpdzQ7P4lQZ/MI9XB8h0+xYbzQ73pNksIGHuDpCpjq4qds/VQaf8RiXYa6amOeI2TU7OiIMHuDDqLAl3P0LEe11fFM2qbIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/menu-separator.png
// module id = 977
// module chunks = 114276838955818